'use client';
// libs
import { ReactElement, useState } from 'react';
import { DialogProviderProps } from './dialog-provider-props.interface';

export function DialogProvider<Data>(props: DialogProviderProps<Data>): ReactElement {
  const { shouldOpenOnInit, children, context } = props;
  const [isOpen, setOpen] = useState<boolean>(shouldOpenOnInit);
  const [data, setData] = useState<Data | null>(null);

  return (
    <context.Provider
      value={{
        isOpen,
        setOpen,
        data,
        setData,
      }}
    >
      {children}
    </context.Provider>
  );
}

export default DialogProvider;
